import { yupResolver } from "@hookform/resolvers/yup";
import Button from "../components/button";
import CheckboxDefault from "../components/checkbox";
// import FormTextArea from "../components/field/textArea";
import Styles from "./styles.module.scss";
import {FormAreaInput} from '../wrappers/formArea'
import FormHead from "../components/headings/FromHead";
import Modal from "../components/modal";
import { FormInput } from "../wrappers/formInput";
import * as Yup from 'yup';
import { useForm } from "react-hook-form";
import { getMultiSelectTreeValue } from "@progress/kendo-react-dropdowns";
import Datepicker from "../components/datepicker";
import * as Utils from '../utils/EllowUtils';
import { useEffect, useMemo, useState } from "react";
import { date } from "yup/lib/locale";
import { Error } from "@progress/kendo-react-labels";
import { EditorState, convertToRaw, convertFromRaw, Modifier, ContentState } from 'draft-js';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";


export type ExperienceFormFields = {
  designation: string;
  companyName: string;
  description: string;
  stillWorking: boolean;
  startDate:number;
  endDate:number;
};

interface Props {
  ClickHandler :any;
  onClose:any;
  defaultValues: {
    workHistoryId: string, status: boolean, designation: string, companyName: string, description: string, startDate:number, endDate:number, stillWorking:boolean}
  }



const validationSchema = Yup.object({

  designation: Yup.string()
  .required('Field is required'),
  companyName: Yup.string()
  .required('Field is required'),
}
)
const ExperienceForm: React.FC<Props> = ({
  ClickHandler,
  onClose,
  defaultValues
}) => { 

  const [checked, setChecked] = useState<boolean>(true)
  const [error, setError] = useState<{startDate?: string, endDate?: string}>({ startDate: '', endDate: ''})
  const [editorState, setEditorState] = useState<any>(EditorState.createEmpty())
  const [startDateState, setStartDateState] = useState<any>()

  const formOptions = {
    resolver:yupResolver(validationSchema)
  }

  // let start = new Date(1648751400000)
  let today = new Date ()
  let startdate = defaultValues?.startDate ? new Date(defaultValues.startDate) :null
  let enddate = defaultValues?.endDate ? new Date(defaultValues.endDate) : null  

   
  const {
    register,
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors },
  } = useForm<ExperienceFormFields>(formOptions);

  useEffect(() => {
    if(defaultValues){
      if (defaultValues.description) {
        setValue('description', defaultValues.description)
        // setEditorState(EditorState.createWithContent(convertFromRaw(JSON.parse(defaultValues.summary)))); 
        const contentState = editorState.getCurrentContent();
        if (JSON.stringify(convertToRaw(contentState)) !== defaultValues.description) {
          try {
            setEditorState(EditorState.createWithContent(convertFromRaw(JSON.parse(defaultValues.description)))); 

          }
          catch (e) {
            setEditorState(EditorState.createWithContent(ContentState.createFromText(defaultValues.description)));
          }

        }
      }

      if (defaultValues?.startDate) {
        setStartDateState(new Date(defaultValues.startDate))
        setChecked(false)
      }

      if(defaultValues.stillWorking === true){
        setChecked(true)
      }
      else {   
       // setChecked(false)
      }
      reset(defaultValues);
      setValue('stillWorking',defaultValues.stillWorking)
    }
  }, [defaultValues]);
 
   
    const onclose = () => {
      onClose()
    }
    
    const changeOn = (e: any, name: any) => {
      if(name==='stillWorking') 
      {
      if(e.target.value === true )
      {
           setChecked(true)
           setValue('stillWorking',true)
           delete error?.endDate 
           setError({...error})
      }
      else{
          //setChecked(false)
          setValue('stillWorking',false)
      }
    }
    if (name === 'startDate'){
      delete error?.startDate   
      setError({ ...error })
      setChecked(false)
      setStartDateState(e.target.value)
    }
    if (name === 'endDate'){
      delete error?.endDate   
      setError({...error})
    }
      setValue(name, e.target.value)      
  }
    
    const onSubmit = (data:any) => {
      let hasError: boolean = false

      if ( data.startDate){
        data.startDate = Utils.getMilliSecUTC(data.startDate)
      }else{
        error.startDate = 'Field is required'
        hasError = true
      }
      if ( data.endDate){
        data.endDate = Utils.getMilliSecUTC(data.endDate)
      }else if (!data.stillWorking){
        error.endDate = 'Field is required'   
        hasError = true
      }
      

      if(data.stillWorking === true){
        data.endDate = 0
      }
      data.action = defaultValues ? 'update' : 'add'
      
      if( !hasError){
        ClickHandler(data)
      }
    }

    const onEditorStateChange = (state: any) => {

      setEditorState(state)
      const contentState = state.getCurrentContent();
      setValue('description', JSON.stringify(convertToRaw(contentState)))
  
    };
 
    return(
      
        <div className={Styles.detailsCard}>
          <form>
          <FormHead>Work History</FormHead> 
            <div className="form-group">
                <FormInput<ExperienceFormFields>
                  id="designation"
                  type="text"
                  name="designation"
                  label="Position*"
                  placeholder=""
                  register={register}
                  errors={errors}
                />
            </div>
            <div className="form-group">
                <FormInput<ExperienceFormFields>
                  id="companyName"
                  type="text"
                  name="companyName"
                  label="Company Name*"
                  placeholder=""
                  register={register}
                  errors={errors}
                />
            </div>
            <div className="form-group">
                <label className="lablel">Role Description</label>
                {/* <FormAreaInput<ExperienceFormFields>
                 id="description"
                 name="description"
                 placeholder=""
                 value={defaultValues.description ? defaultValues.description : ''}
                 register={register}
                 onchange={(e: any) => changeOn(e, 'description')}
                 errors={errors}>         
                </FormAreaInput> */}
                <Editor
                  editorState={editorState}
                  toolbarClassName="toolbarClassName"
                  wrapperClassName="wrapperClassName"
                  editorClassName="editorClassName"
                  onEditorStateChange={onEditorStateChange}
                />
            </div>
            <div className="half-form-wrap mb-0">
            <div className="form-group">
                  {/* <FormInput<EducationModalFormFields>
                    id="startdate"
                    type="text"
                    name="startdate"
                    label="Start Date*"
                    placeholder=""
                    register={register}
                    errors={errors}
                  /> */}
                  <label className="lablel">Start Date*</label>
                  <Datepicker
                  defaultShow={false}
                  defaultValue={startdate}
                  onChange={(e: any) => changeOn(e, 'startDate')}
                  />
                  <Error>{error?.startDate}</Error>
              </div>
            <div className="form-group">
                {/* <FormInput<EducationModalFormFields>
                  id="enddate"
                  type="text"
                  name="enddate"
                  register={register}
                  errors={errors}
                  label="End Date*"
                  placeholder=""
                /> */}
                <label className="lablel">End Date*</label>
                  <Datepicker
                  defaultShow={false}
                  defaultValue={enddate}
                  onChange={(e: any) => changeOn(e, 'endDate')}
                  disabled={checked ? true : false}
                  min={startDateState}
                  />
                  <Error>{error?.endDate}</Error>
            </div>
            </div>
            <div className="form-group">
              <CheckboxDefault name='stillWorking' defaultChecked={defaultValues.stillWorking === true && defaultValues.stillWorking} onchange={(e: any) => changeOn(e, 'stillWorking')} label="Still Working" />
            </div>
            <div className={Styles.popupAction}>
              <Button onClick={onclose} type="submit" variant="secondary" size="small">Cancel</Button>
              <Button onClick={handleSubmit(onSubmit)} type="submit" variant="primary" size="small">Save</Button>
            </div>
            </form>
          </div>
         
    )
}

export default ExperienceForm;